/**
 * Tras un despliegue, una pagina que ya estaba abierta sigue apuntando a los ficheros
 * de pantalla de la version anterior, que ya no existen: nginx devuelve index.html y
 * el navegador rechaza el modulo. En ese caso se recarga la pagina UNA vez para traer
 * la version nueva.
 *
 * Una vez POR VERSION, no por tiempo: la marca guarda la version con la que se recargo
 * (el nombre del fichero de entrada, que cambia en cada build). Si la version nueva
 * tambien falla, no se recarga mas y el error llega al ErrorBoundary de la pantalla.
 * Sin red no se recarga: la pagina se iria a la pantalla de "sin conexion" del navegador.
 */
export const MARCA_RECARGA_PANTALLA = 'fluxo-recarga-pantalla';

export interface EntornoRecarga {
  /** Identificador de esta build (cambia en cada despliegue). */
  version: string;
  enLinea: () => boolean;
  leer: (clave: string) => string | null;
  guardar: (clave: string, valor: string) => void;
  recargar: () => void;
}

function entornoNavegador(): EntornoRecarga | null {
  if (typeof window === 'undefined') return null;
  return {
    // En la build este modulo va dentro del fichero de entrada (index-HASH.js): su URL es la version.
    version: import.meta.url,
    enLinea: () => typeof navigator === 'undefined' || navigator.onLine !== false,
    leer: (clave) => window.sessionStorage.getItem(clave),
    guardar: (clave, valor) => window.sessionStorage.setItem(clave, valor),
    recargar: () => window.location.reload(),
  };
}

export function conRecargaUnaVez<T>(cargar: () => Promise<T>, entorno: () => EntornoRecarga | null = entornoNavegador): () => Promise<T> {
  return () => cargar().catch((error: unknown) => {
    const e = entorno();
    if (!e || !e.enLinea()) throw error;
    try {
      if (e.leer(MARCA_RECARGA_PANTALLA) === e.version) throw error;
      e.guardar(MARCA_RECARGA_PANTALLA, e.version);
    } catch {
      // Ya se recargo con esta version, o no hay almacenamiento de sesion para evitar un bucle.
      throw error;
    }
    e.recargar();
    // La pagina se esta yendo: no se pinta el error mientras tanto.
    return new Promise<T>(() => undefined);
  });
}
